// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__WrryV","notes":"Notes_notes__Xno6H"};